<template>
  <div>
    <textarea
      v-model="model.app_comments"
      :placeholder="placeholder"
      rows="3"
      class="form-control"
      :class="{ 'is-invalid': errors.has('app_comments') }"
    ></textarea>
    <div class="invalid-feedback" v-if="errors.has('app_comments')">
      {{ errors.first('app_comments') }}
    </div>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'comment',
  props: ['value', 'validate', 'placeholder'],
  data() {
    return {
      model: {},
      errors: new Errors()
    }
  },
  created() {
    this.model = this.value
  },
  methods: {},
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
